/* =======================================================================
   GALLERY.JS — Foto della pagina Galleria
   =======================================================================
   La pagina Galleria mostra tutte le foto qui dichiarate, in layout
   "masonry" che preserva l'aspect ratio originale (nessun ritaglio).

   ===  COME AGGIUNGERE UNA NUOVA FOTO ===
   1. Metti il file (es. "nuova.jpg") nella cartella:
        public/assets/photos/real/
   2. Aggiungi UNA RIGA nella lista qui sotto:
        { src: asset("/assets/photos/real/nuova.jpg"),
          alt: { it: "descrizione in italiano", en: "description in english" } },

   ===  COME RIMUOVERE UNA FOTO ===
   Cancella la riga corrispondente da questa lista
   (o, opzionalmente, anche il file dalla cartella).

   ===  COME CAMBIARE L'ORDINE ===
   Sposta le righe nell'ordine desiderato (le prime in alto = mostrate prima).
   ======================================================================= */
import { asset } from "@/utils/asset";

// Helper per generare automaticamente la lista delle 43 foto gal-01...gal-43
// (è una scorciatoia. Se preferisci scrivere le 43 foto a mano per
// modificarne i titoli o l'ordine, sostituisci con un array tradizionale.)
const a = (n) => ({
  src: asset(`/assets/photos/real/gal-${String(n).padStart(2, "0")}.jpg`),
  alt: { it: `Le Simpatiche Canaglie · foto ${n}`, en: `Le Simpatiche Canaglie · photo ${n}` },
});

export const galleryImages = Array.from({ length: 43 }, (_, i) => a(i + 1));

/* ESEMPIO di lista tradizionale (se preferisci):
export const galleryImages = [
  { src: asset("/assets/photos/real/gal-01.jpg"), alt: { it: "Panettoni", en: "Panettoni" } },
  { src: asset("/assets/photos/real/gal-02.jpg"), alt: { it: "Massimiliano", en: "Massimiliano" } },
  // ...
];
*/
